import React from 'react';
import { AlertTriangle, Pencil, UserCheck } from 'lucide-react';

const VARIANTS = {
  delete:  { icon: <AlertTriangle size={20} className="text-red-600" />,   bg: 'bg-red-100',   title: 'Confirm Delete',    btn: 'bg-red-600 hover:bg-red-700 text-white',           label: 'Yes, Delete' },
  update:  { icon: <Pencil size={20} className="text-blue-600" />,          bg: 'bg-blue-100',  title: 'Confirm Update',    btn: 'bg-blue-600 hover:bg-blue-700 text-white',          label: 'Yes, Update' },
  assign:  { icon: <UserCheck size={20} className="text-indigo-600" />,     bg: 'bg-indigo-100',title: 'Confirm Assignment', btn: 'bg-indigo-600 hover:bg-indigo-700 text-white',      label: 'Yes, Assign' },
};

export default function ConfirmModal({
  message,
  onConfirm,
  onCancel,
  variant = 'delete',
  title,
  confirmLabel,
  confirmClass,
}) {
  const v = VARIANTS[variant] || VARIANTS.delete;
  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={onCancel}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6" onClick={e => e.stopPropagation()}>
        <div className="flex items-start gap-3 mb-4">
          <div className={`w-10 h-10 rounded-full ${v.bg} flex items-center justify-center flex-shrink-0`}>{v.icon}</div>
          <div>
            <h3 className="font-semibold text-gray-900 mb-1">{title || v.title}</h3>
            <p className="text-sm text-gray-600">{message || 'Are you sure?'}</p>
          </div>
        </div>
        <div className="flex gap-3">
          <button onClick={onConfirm} className={`flex-1 py-2 rounded-lg font-medium text-sm transition-colors ${confirmClass || v.btn}`}>{confirmLabel || v.label}</button>
          <button onClick={onCancel} className="flex-1 py-2 rounded-lg font-medium text-sm border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors">Cancel</button>
        </div>
      </div>
    </div>
  );
}
